import {
    CONFIRMED_CREATE_USER_ACTION,
    CONFIRMED_DELETE_USER_ACTION,
    CONFIRMED_EDIT_USER_ACTION,
    CONFIRMED_GET_USERS,
    CREATE_USER_ACTION,    
    CREATE_USER_ERROR_ACTION,
    CLEAR_USER_ERROR,
    LOADING_USERS ,
    CONFIRMED_UPDATE_STATUS_ACTION   
} from '../actions/UserTypes';

const initialState = {
    users: [],
    loading: false,
    createUserError: {}
};

export default function UserReducer(state = initialState, actions) {
    if (actions.type === CREATE_USER_ACTION) { 
        return {
            ...state,
            users: [...state.users],
        };
    }

    if (actions.type === CONFIRMED_DELETE_USER_ACTION) {
        const users = state.users.filter(user => user.id !== actions.payload);
        return {
            ...state,
            users,
        };
    }

    if (actions.type === CONFIRMED_EDIT_USER_ACTION) {
        const users = state.users.map(user => 
            user.id === actions.payload.id ? actions.payload : user
        );
        return {
            ...state,
            users,
        };
    }

    if (actions.type === CONFIRMED_CREATE_USER_ACTION) {
        return {
            ...state,
            users: [...state.users, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_USERS) {
       
        return {
            ...state,
            users: actions.payload,
        };
    }

    if (actions.type === CONFIRMED_UPDATE_STATUS_ACTION) {
          console.log(actions.payload)  ;   
        const users = state.users.map(user => 
            user.id === actions.payload.userId ? { ...user, status: actions.payload.status  } : user
        );
        return {
            ...state,
            users,
        };
    }

    if (actions.type === LOADING_USERS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_USER_ERROR_ACTION) {
        return {
            ...state,
            createUserError: actions.payload,
        };
    }

    if (actions.type === CLEAR_USER_ERROR) {
        return {
            ...state,
            createUserError: {},
        };
    }
  
    return state;
}
